import React from 'react';
import {
    Navbar,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from 'reactstrap';
import { SSL_PAGE, PASSPORT4WEB, STS_HP} from '../../assets/const';
import logo from '../../assets/images/logo_0.png';
import pfwlogo from '../../assets/images/B0594121.gif';
import { getSessionInfo } from '../../assets/common';

export default class MenuList extends React.Component{
    componentDidMount = () => {
        getSessionInfo();
    }  

    render(){
        return(
            <div>
                <Navbar color="light" light expand="md">
                    <Nav>
                    <span className="navbar-brand">
                        <a href={STS_HP}><img src={logo} alt="SECOM" width="121" height="70" /></a>
                    </span>                        
                        <NavItem>
                            <NavLink href="/Home">WAN運用支援サービスHOME</NavLink>
                        </NavItem>
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret>
                                レポート
                            </DropdownToggle>
                            <DropdownMenu right>
                                <NavLink href="/ReportBase">拠点別レポート</NavLink>
                                <NavLink href="/ReportItem">項目別レポート</NavLink>                            
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        <NavItem>
                            <NavLink href="/AccountEdit">パスワード編集</NavLink>
                        </NavItem>                    
                        <NavItem>
                            <NavLink href={PASSPORT4WEB}>SSL証明書<br/>ご案内</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="/Logout" >ログアウト</NavLink>
                        </NavItem> 
                        <NavItem>
                            <NavLink>
                                    {/* WEBステッカー */}
                                    {/* 検証環境用 */}
                                    {/* <form action="https://www.login.secomtrust.net/customer/customer/pfw/CertificationPage.do" 
                                        name="CertificationPageForm" method="post" target="_blank" style={{margin:"0"}}>
                                        <input type="image" src={pfwlogo} width="44" height="70" name="Sticker" alt="クリックして証明書の内容をご確認ください" oncontextmenu="return false;" />
                                        <input type="hidden" name="Req_ID" value="0342472373" />
                                    </form> */}

                                    {/* 本番環境用 */}
                                    {/* 更新後 */}
                                    <form action="https://www.login.secomtrust.net/customer/customer/pfw/CertificationPage.do" 
                                        name="CertificationPageForm" method="post" target="_blank" style={{margin:"0"}}>
                                        <input type="image" src={pfwlogo} width="44" height="70" name="Sticker" alt="クリックして証明書の内容をご確認ください" oncontextmenu="return false;" />
                                        <input type="hidden" name="Req_ID" value="6351567316" />
                                    </form>
                                    {/* 更新前 */}
                                    {/* <form action="https://www.login.secomtrust.net/customer/customer/pfw/CertificationPage.do" 
                                        name="CertificationPageForm" method="post" target="_blank" style={{margin:"0"}}>
                                        <input type="image" src={pfwlogo} width="44" height="70" name="Sticker" alt="クリックして証明書の内容をご確認ください" oncontextmenu="return false;" />
                                        <input type="hidden" name="Req_ID" value="9979565061" />
                                    </form> */}
                            </NavLink>
                        </NavItem>                        
                    </Nav>
                </Navbar>
            </div>
        )
    }  
}
